import { AutoContentGenerator } from '@/components/AutoContentGenerator';

export const AutoContentGeneration = () => {
  return <AutoContentGenerator />;
};